import { AMBASSADOR_INFO } from '@mm/api-routes';
import AuthenticatedController from './AuthenticatedController';

export type AmbassadorFields = {
  title?: string;
  description?: string;
  assetId?: number;
  name?: string;
  publish?: boolean;
};

export class AmbassadorInfoController extends AuthenticatedController {
  static fetch() {
    return super.get(AMBASSADOR_INFO);
  }

  static update(ambassadorFields: AmbassadorFields) {
    return super.put(AMBASSADOR_INFO, ambassadorFields);
  }

  static publish() {
    return super.post(`${AMBASSADOR_INFO}/publish`);
  }

  static check(name: string) {
    return super.get(`${AMBASSADOR_INFO}/check`, { name });
  }
}
